// file created at 2020-3-4
// Auto-generated files PaletteCopier.ts

import { Vue, Component, Prop } from 'vue-property-decorator';
import Palette from '@/interfaces/Palette';
import { sortForDisplay } from '@/utils/palette-utils';

@Component({})
export default class PaletteCopier extends Vue {

  @Prop() private currentPalette!: Palette;

  protected mounted() {
    //
  }

  protected get colorCodes() {
    return sortForDisplay([...this.currentPalette]).map(c => (c.data.rgb as d3.RGBColor).hex());
  }

  protected copyTexts(texts: string[]) {
    this.copyToClipboard(JSON.stringify(texts));
    alert(`copied! ${JSON.stringify(texts)}`);
  }

  private copyToClipboard(text: string) {
    const textAreaElement = document.createElement('textarea');
    document.body.appendChild(textAreaElement);
    textAreaElement.value = text;
    textAreaElement.select();
    document.execCommand('copy');
    document.body.removeChild(textAreaElement);
  }

}
